import Vue from 'vue'
import VueRouter from 'vue-router'

import Basics from '../views/Basics.vue'
import Login from '../views/Login.vue'

import Home from '../views/Home.vue'


//-------------------------------------系统设置------------------------------------------
// 系统参数管理
import SystemParameter from '../views/system/SystemParameter.vue'
// 职责管理
import Duty from '../views/system/Duty.vue'


//-------------------------------------组织架构管理------------------------------------------
// 企业管理
import Enterprise from '../views/organization/Enterprise.vue'
// 职位管理
import Position from '../views/organization/Position.vue'
// 部门管理
import Department from '../views/organization/Department.vue'
// 部门管理
import Staff from '../views/organization/Staff.vue'


//-------------------------------------服务商管理------------------------------------------
// 服务商设置
import Facilitator from '../views/facilitator/Facilitator.vue'
//设备类型
import Devicetype from '../views/facilitator/Devicetype.vue'
//设备类型
import Businesstype from '../views/facilitator/Businesstype.vue'
//设备类型
import Crowdtype from '../views/facilitator/Crowdtype.vue'

//-------------------------------------票务信息设置------------------------------------------
//----------------产品管理
//基础票
import BasicTicket from '../views/ticketInfo/BasicTicket.vue'
//价格管理
import PriceManage from '../views/ticketInfo/PriceManage.vue'
//库存设置
import InventorySettings from '../views/ticketInfo/InventorySettings.vue'
//库存详情
import InventoryDetails from '../views/ticketInfo/InventoryDetails.vue'

//-------------------------------------票务销售设置------------------------------------------
//售票站点
import TicketStation from '../views/ticketSales/TicketStation.vue'
//售票窗口
import TicketWindow from '../views/ticketSales/TicketWindow.vue'
//售票窗口
import Salewindow from '../views/ticketSales/Salewindow.vue'
//员工售票权限
import Salestaff from '../views/ticketSales/Salestaff.vue'

//-------------------------------------检票设置------------------------------------------
//园门管理
import CheckStation from '../views/ticketCheck/CheckStation.vue'
//售票站点
import Checkdevice from '../views/ticketCheck/Checkdevice.vue'


//-------------------------------------线下售检数据报表------------------------------------------
//售票流水查询
import TicktingFlow from '../views/offlineReport/TicketingFlow.vue'
//订单详情
import OrderDetails from '../views/offlineReport/OrderDetails.vue'
//售票员销售报表
import StaffReport from '../views/offlineReport/StaffReport.vue'


//-------------------------------------预制票管理------------------------------------------
//仓库管理
import Pflibrary from '../views/prefabricate/Pflibrary.vue'
//票号规则
import Pfrule from '../views/prefabricate/Pfrule.vue'
//领用出库
import Pfout from '../views/prefabricate/Pfout.vue'



Vue.use(VueRouter)

const routes = [
	{ path: '/Login', name: 'Login', component: Login },
	{ path: '/', redirect: '/Login'},
	{ 
		path: '/Basics',
		name: 'Basics',
		component: Basics,
		children: [
			{ path: '/Home', name: 'Home', component: Home },
			
			{ path: '/SystemParameter', name: 'SystemParameter', component: SystemParameter },
			{ path: '/Duty', name: 'Duty', component: Duty },
			
			{ path: '/Enterprise', name: 'Enterprise', component: Enterprise },
			{ path: '/Position', name: 'Position', component: Position },
			{ path: '/Department', name: 'Department', component: Department },
			{ path: '/Staff', name: 'Staff', component: Staff },
			
			{ path: '/Facilitator', name: 'Facilitator', component: Facilitator },
			{ path: '/Devicetype', name: 'Devicetype', component: Devicetype },
			{ path: '/Businesstype', name: 'Businesstype', component: Businesstype },
			{ path: '/Crowdtype', name: 'Crowdtype', component: Crowdtype },
			
			{ path: '/BasicTicket', name: 'BasicTicket', component: BasicTicket },
			{ path: '/PriceManage', name: 'PriceManage', component: PriceManage },
			{ path: '/InventorySettings', name: 'InventorySettings', component: InventorySettings },
			{ path: '/InventoryDetails', name: 'InventoryDetails', component: InventoryDetails },
			
			{ path: '/TicketStation', name: 'TicketStation', component: TicketStation },
			{ path: '/TicketWindow', name: 'TicketWindow', component: TicketWindow },
			{ path: '/Salewindow', name: 'Salewindow', component: Salewindow },
			{ path: '/Salestaff', name: 'Salestaff', component: Salestaff },
			
			{ path: '/CheckStation', name: 'CheckStation', component: CheckStation },
			{ path: '/Checkdevice', name: 'Checkdevice', component: Checkdevice },
			
			{ path: '/TicktingFlow', name: 'TicktingFlow', component: TicktingFlow },
			{ path: '/OrderDetails', name: 'OrderDetails', component: OrderDetails },
			{ path: '/StaffReport', name: 'StaffReport', component: StaffReport },
			
			{ path: '/Pflibrary', name: 'Pflibrary', component: Pflibrary },
			{ path: '/Pfrule', name: 'Pfrule', component: Pfrule },
			{ path: '/Pfout', name: 'Pfout', component: Pfout },
			
		]
	}

]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
